angular
    .module('MW.ContactManager.ContactManagerContactModel', [
        'MW.ContactManager.ContactManagerPropertyTypeService'
    ])
    .factory('Contact', [
        'emailTypes',
        'phoneNumberTypes',
        'addressTypes',
        'activeOnTypes',
        'FairhairChannelTypes',
        'FairhairSocialProfileTypes',
        function(emailTypes,
                 phoneNumberTypes,
                 addressTypes,
                 activeOnTypes,
                 FairhairChannelTypes,
                 FairhairSocialProfileTypes
        ) {
            'use strict';

            function Contact(descriptor, sourcesObject) {
                descriptor = descriptor || {};

                // ID
                if(descriptor.id) {
                    this.id = descriptor.id;
                }

                // NAME
                this.name = descriptor.name || {
                    prefix: undefined,
                    firstName: '',
                    middleName: '',
                    lastName: ''
                };
                this.name.middleName = this.name.middleName || '';
                this.name.fullName = '';
                this.name.fullName += this.name.firstName || '';
                this.name.fullName += this.name.middleName ? (' ' + this.name.middleName) : '';
                this.name.fullName += this.name.lastName ? (' ' + this.name.lastName) : '';
                this.unsubscribed = false;
                // CONTACT INFO
                this.contactInfo = {};
                descriptor.contactInfo = descriptor.contactInfo || {};

                this.contactInfo.email = (Array.isArray(descriptor.contactInfo.email) && descriptor.contactInfo.email.length) ? descriptor.contactInfo.email : [{
                    type: emailTypes.WORK,
                    address: ''
                }];

                this.contactInfo.phone = (Array.isArray(descriptor.contactInfo.phone) && descriptor.contactInfo.phone.length) ? descriptor.contactInfo.phone : [{
                    type: phoneNumberTypes.WORK,
                    number: ''
                }];

                // TODO: remove this once the IM changes back to contactInfo.addresses (rather than contactInfo.address)
                // Setting 'addresses' based on 'addresses' OR 'address' to handle current state
                descriptor.contactInfo.address = descriptor.contactInfo.addresses || descriptor.contactInfo.address;

                this.contactInfo.address = (Array.isArray(descriptor.contactInfo.address) && descriptor.contactInfo.address.length) ? descriptor.contactInfo.address : [{
                    type: addressTypes.WORK,
                    street: '',
                    street2: '',
                    city: '',
                    zip: '',
                    countryName: '',
                    stateOrProvince: ''
                }];

                this.contactInfo.address.forEach(function addressLoop(address){
                    this.isAddressEmpty(address);
                }.bind(this));

                // NOTES
                this.notes = (Array.isArray(descriptor.notes) && descriptor.notes.length) ? descriptor.notes : [''];
                this.channels = descriptor.channels ? descriptor.channels : [];
                var sourceMap = {};

                this.channels.forEach(function(channel){
                    if(channel.sourceId) {
                        sourceMap[channel.sourceId] = channel;
                    }
                });

                // SOURCES - Populate sources into channels for all contacts and filter out the duplicates
                if (descriptor.sourceSnippets) {
                    descriptor.sourceSnippets.forEach(function(source) {
                        if (source.sourceType !== 'bureau') { // add the non-bureau into the channels
                            source.type = activeOnTypes.SOURCE;
                            this.channels.push(source);
                            sourceMap[source.id] = source; // update the sourceMap with more sufficient source info
                        }
                    }.bind(this));
                }

                this.pruneChannelSources(this.channels, sourcesObject);
                if (descriptor.socialProfiles && descriptor.socialProfiles.length) {
                    descriptor.socialProfiles.forEach(function(socialProfile) {
                        var missingProfile = false;
                        this.channels.filter(function(channel) {
                            if(channel.socialProfile && channel.socialProfile.type === socialProfile.type) {
                                missingProfile = true;
                                return false;
                            }
                        });
                        if (missingProfile === false) {
                            this.channels.push(socialProfile);
                        }
                    }.bind(this));
                }
                this.addChannelTypes(this.channels, sourcesObject);

                this.title = descriptor.title || [];
                this.description = descriptor.description || '';
                this.beats = descriptor.beats || [];
                this.systemData = descriptor.systemData || [];
                this.mediaLists = descriptor.mediaLists || [];
                this.roles = descriptor.roles || [];
                if (descriptor.contactInfo.email && Array.isArray(descriptor.contactInfo.email) && descriptor.contactInfo.email[0] && descriptor.contactInfo.email[0].unsubscribed) {
                    this.contactInfo.email.map(function (value, index) {
                        value.unsubscribed = (descriptor.contactInfo.email[index].unsubscribed) ? descriptor.contactInfo.email[index].unsubscribed : false;
                        return value;
                    });
                } else {
                    this.contactInfo.email.map(function (value) {
                        value.unsubscribed = false;
                        return value;
                    });
                }
                if (descriptor.relevantArticles) {
                    this.relevantArticles = descriptor.relevantArticles;
                } else {
                    this.relevantArticles = 0;
                }

                this.updated = descriptor.updated || null;

                if(descriptor.lat && descriptor.lon) {
                    this.lat = descriptor.lat;
                    this.lon = descriptor.lon;
                }

                this.automated = descriptor.automated || false;
            }   

            Contact.prototype.addChannelTypes = function addChannelTypes(channels, sources){
                var sourceObj = {},
                    sourceIds = [];
                if(sources){
                    sources.map(function(source){
                        sourceObj[source.id] = source;
                    });
                }

                if(channels && channels.length > 0) {
                    channels.forEach(function(channel, i, arr) {
                        switch(channel.type) {
                            case FairhairChannelTypes.WEBSITE:
                                channel.type = activeOnTypes.BLOG;
                                break;
                            case FairhairChannelTypes.SOCIAL:
                                switch(channel.socialProfile.type) {
                                    case FairhairSocialProfileTypes.TWITTER:
                                        arr[i] = channel.socialProfile;
                                        arr[i].type = activeOnTypes.TWITTER;
                                        break;
                                    case FairhairSocialProfileTypes.FACEBOOK:
                                        arr[i] = channel.socialProfile;
                                        arr[i].type = activeOnTypes.FACEBOOK;
                                        break;
                                    case FairhairSocialProfileTypes.LINKED_IN:
                                        arr[i] = channel.socialProfile;
                                        arr[i].type = activeOnTypes.LINKED_IN;
                                        break;
                                    default:
                                        break;
                                }
                                break;
                            case FairhairSocialProfileTypes.TWITTER:
                                channel.type = activeOnTypes.TWITTER;
                                break;
                            case FairhairSocialProfileTypes.FACEBOOK:
                                channel.type = activeOnTypes.FACEBOOK;
                                break;
                            case FairhairSocialProfileTypes.LINKED_IN:
                                channel.type = activeOnTypes.LINKED_IN;
                                break;
                            case activeOnTypes.SOURCE:
                                if(sourceObj && sourceObj[channel.id]) {
                                    if (sourceIds.indexOf(channel.id) === -1) {
                                        arr[i] = sourceObj[channel.id];
                                        arr[i].type = activeOnTypes.SOURCE;
                                        sourceIds.push(channel.sourceId);
                                    }
                                    else {
                                        arr.splice(i, 1);
                                    }
                                }
                                break;
                            case FairhairChannelTypes.SOURCE:
                                if(sourceObj && sourceObj[channel.sourceId]) {
                                    if (sourceIds.indexOf(channel.sourceId) === -1) {
                                        arr[i] = sourceObj[channel.sourceId];
                                        arr[i].type = FairhairChannelTypes.SOURCE;
                                        sourceIds.push(channel.sourceId);
                                    }
                                }
                                else {
                                    // this channel.sourceId does not match any sources.
                                    arr[i].type = 'unknown';
                                }
                                break;
                            default:
                                break;
                        }
                    }, this);
                }
            };

            Contact.prototype.pruneChannelSources = function pruneChannelSources(channels, sources) {
                var channel,
                    index;
                if (sources) {
                    sources.forEach(function(source){
                        if(source.parentIds && source.sourceType !== 'bureau'){
                            source.parentIds.forEach(function(id){
                                channels.forEach(function(channel, index, arr){
                                    if(channel.sourceId && channel.sourceId === id){
                                        arr.splice(index, 1);
                                    }
                                });
                            });
                        } else {
                            for (index = channels.length - 1; index >=0; index--) {
                                channel = channels[index];
                                if(channel.sourceId) {
                                    if(channel.sourceId === source.id) {
                                        channels.splice(index, 1);
                                    }
                                }
                            }
                        }
                    });
                }
            };

            Contact.prototype.isAddressEmpty = function isAddressEmpty(address){
                var addressFieldArray = ['city', 'countryCode', 'countryName', 'stateOrProvince', 'street', 'street2', 'zip'];
                address.isAddressEmpty = true;
                addressFieldArray.forEach(function fieldLoop(field){
                    if (!!address[field]) {
                        address.isAddressEmpty = false;
                    }
                });
            };

            Contact.prototype.getEmail = function getEmail() {
                if (this.contactInfo.email[0]) {
                    return this.contactInfo.email[0].address;
                } else {
                    return null;
                }
            };

            Contact.prototype.getUnsubscribedStatus = function getUnsubscribedStatus() {
                return !!(this.contactInfo.email[0] && this.contactInfo.email[0].unsubscribed);
            };

            Contact.prototype.setUnsubscribedStatus = function setUnsubscribedStatus(email) {
                    this.unsubscribed = (this.contactInfo.email[0].address.toLowerCase() === email.toLowerCase());
            };

            return Contact;
        }
    ]);
